import React, { useEffect, useState, useMemo } from "react";
import {
  getNotesByUserId,
  createNote,
  Note,
  updateNote,
  deleteNote,
} from "../../api/notes";
import { Select } from "antd";
import { toast } from "react-toastify";
import { RootState } from "../../core/data/redux/store";
import { useSelector } from "react-redux";
import Table from "../../core/common/dataTable/index";
import type { ColumnsType } from "antd/es/table";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { highlightMatch } from "../../core/common/highlightmatch";
import PageLoadProgressBar from "../../core/data/json/pageLoadProgressBar";
import { validateNoteDescription } from "../../api/applicationValidation";
import ScrollToTop from "../../core/common/ScrollToTop";
import ModalDeleteEffect from "../../core/common/ModalDeleteEffect";
import ColumnManagement from "../../core/common/ColumnManagement";
import { useColumnOrderSave } from "../../core/common/useColumnOrderSave";


const Notes: React.FC = () => {
  const [notes, setNotes] = useState<Note[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [noteInput, setNoteInput] = useState("");
  const [editNoteId, setEditNoteId] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [deleteNoteId, setDeleteNoteId] = useState<string | null>(null);
  const userId = useSelector((state: RootState) => state.auth.user_id);
    const userRole = useSelector((state: RootState) => state.auth.role);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const route = all_routes;
  const [sortOption, setSortOption] = useState<"ascending" | "descending">("ascending");
const [noteError, setNoteError] = useState<string>("");
const [noteValid, setNoteValid] = useState<boolean>(false);
const [deleting, setDeleting] = useState(false);
const defaultColumnOrder = [
    "index",
    "notes_decription",
    "actions",
  ];
    const [openAccordion, setOpenAccordion] = useState<string | null>(null);
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [orderedData, setOrderedData] = useState<Note[]>([]);
  const [columnKeys, setColumnKeys] = useState<string[]>(() => {
      const saved = localStorage.getItem("noteColumnKeys");
      if (saved) return JSON.parse(saved);
      return defaultColumnOrder;
    });
    // Hook for save prompt on navigation/refresh
      const { SaveModal } = useColumnOrderSave({
        columnKeys,
        localStorageKey: "noteColumnKeys",
        defaultOrder: defaultColumnOrder,
      });

      const handleRowOrderChange = (newOrdered: Note[]) => {
          setOrderedData(newOrdered);
          // OPTIONAL: persist to backend
          // await reorderLeadSources(newOrdered.map(r => r.LeadSource_id));
        };

useEffect(() => {
    const makeModalDraggable = (modalId: string) => {
      const modalElement = document.getElementById(modalId);
      if (!modalElement) return;

      const modalDialog = modalElement.querySelector(
        ".modal-dialog"
      ) as HTMLElement;
      const modalHeader = modalElement.querySelector(
        ".modal-header"
      ) as HTMLElement;

      if (!modalDialog || !modalHeader) return;

      let isDragging = false;
      let currentX = 0;
      let currentY = 0;
      let initialX = 0;
      let initialY = 0;
      let startX = 0;
      let startY = 0;

      // Reset position when modal is shown
      const resetPosition = () => {
        // Reset all position variables
        currentX = 0;
        currentY = 0;
        initialX = 0;
        initialY = 0;
        startX = 0;
        startY = 0;
        isDragging = false;

        // Remove only the inline styles that were added during dragging
        modalDialog.style.position = "";
        modalDialog.style.top = "";
        modalDialog.style.left = "";
        modalDialog.style.transform = "";
        modalDialog.style.margin = "";
        modalDialog.style.transition = "";
        modalDialog.style.width = "";
        modalDialog.style.maxWidth = "";

        // Restore centered class if it was removed
        if (!modalDialog.classList.contains("modal-dialog-centered")) {
          modalDialog.classList.add("modal-dialog-centered");
        }
      };

      // Listen for modal show event - reset when modal is about to show
      const handleShow = () => {
        // Reset immediately when modal starts showing
        resetPosition();
      };

      // Listen for modal shown event - ensure reset after modal is fully displayed
      const handleShown = () => {
        // Double-check reset after modal is fully shown
        resetPosition();
      };

      // Listen for modal hidden event - reset when modal is fully hidden
      const handleHidden = () => {
        resetPosition();
      };

      modalElement.addEventListener("show.bs.modal", handleShow);
      modalElement.addEventListener("shown.bs.modal", handleShown);
      modalElement.addEventListener("hidden.bs.modal", handleHidden);

      const dragStart = (e: MouseEvent) => {
        // Only allow dragging from header, not from close button or other interactive elements
        const target = e.target as HTMLElement;
        if (
          target.closest(".btn-close") ||
          target.closest("button") ||
          target.closest("input") ||
          target.closest("select")
        ) {
          return;
        }

        if (
          e.target === modalHeader ||
          modalHeader.contains(e.target as Node)
        ) {
          isDragging = true;
          modalHeader.style.cursor = "move";

          // Get current position and size of modal dialog
          const rect = modalDialog.getBoundingClientRect();
          startX = rect.left;
          startY = rect.top;

          // Get computed styles to preserve the modal's size
          const computedStyle = getComputedStyle(modalDialog);
          const currentWidth = computedStyle.width;
          const currentMaxWidth = computedStyle.maxWidth;
          const currentMinWidth = computedStyle.minWidth;

          // Remove centered class to allow free movement
          modalDialog.classList.remove("modal-dialog-centered");

          // Set initial position based on current position
          modalDialog.style.position = "fixed";
          modalDialog.style.top = `${startY}px`;
          modalDialog.style.left = `${startX}px`;
          modalDialog.style.margin = "0";
          modalDialog.style.transform = "none";
          modalDialog.style.transition = "none";

          // Preserve the modal's width and max-width to prevent size change
          if (
            currentWidth &&
            currentWidth !== "auto" &&
            currentWidth !== "0px"
          ) {
            modalDialog.style.width = currentWidth;
          }
          if (
            currentMaxWidth &&
            currentMaxWidth !== "none" &&
            currentMaxWidth !== "0px"
          ) {
            modalDialog.style.maxWidth = currentMaxWidth;
          }
          if (
            currentMinWidth &&
            currentMinWidth !== "0px" &&
            currentMinWidth !== "auto"
          ) {
            modalDialog.style.minWidth = currentMinWidth;
          }

          initialX = e.clientX - startX;
          initialY = e.clientY - startY;
        }
      };

      const drag = (e: MouseEvent) => {
        if (!isDragging) return;

        e.preventDefault();

        // Calculate new position
        const newX = e.clientX - initialX;
        const newY = e.clientY - initialY;

        // Get modal dialog dimensions
        const rect = modalDialog.getBoundingClientRect();
        const maxX = window.innerWidth - rect.width;
        const maxY = window.innerHeight - rect.height;

        // Constrain to viewport
        const constrainedX = Math.max(0, Math.min(newX, maxX));
        const constrainedY = Math.max(0, Math.min(newY, maxY));

        // Update position
        modalDialog.style.left = `${constrainedX}px`;
        modalDialog.style.top = `${constrainedY}px`;

        // Store current position for next drag
        currentX = constrainedX;
        currentY = constrainedY;
      };

      const dragEnd = () => {
        if (isDragging) {
          isDragging = false;
          modalHeader.style.cursor = "move";
          modalDialog.style.transition = "";
          // Keep the fixed positioning during drag, but allow reset on next open
        }
      };

      // Add cursor style to header
      modalHeader.style.cursor = "move";
      modalHeader.style.userSelect = "none";

      // Event listeners
      modalHeader.addEventListener("mousedown", dragStart);
      document.addEventListener("mousemove", drag);
      document.addEventListener("mouseup", dragEnd);

      // Cleanup function
      return () => {
        modalElement.removeEventListener("show.bs.modal", handleShow);
        modalElement.removeEventListener("shown.bs.modal", handleShown);
        modalElement.removeEventListener("hidden.bs.modal", handleHidden);
        modalHeader.removeEventListener("mousedown", dragStart);
        document.removeEventListener("mousemove", drag);
        document.removeEventListener("mouseup", dragEnd);
      };
    };

    // Make all three modals draggable
    const cleanup1 = makeModalDraggable("add_note");
    const cleanup2 = makeModalDraggable("edit_calls");
    const cleanup3 = makeModalDraggable("delete_note");
    const cleanup4 = makeModalDraggable("bulk_delete_modal");
    const cleanup5 = makeModalDraggable("import_excel_modal");
    const cleanup6 = makeModalDraggable("user_report_modal");

    return () => {
      cleanup1?.();
      cleanup2?.();
      cleanup3?.();
      cleanup4?.();
      cleanup5?.();
      cleanup6?.();
    };
  }, []);

const handleAccordionToggle = (key: string) => {
    setOpenAccordion((prev) => (prev === key ? null : key));
  };

  const handleFilterChange = (
      value: string,
      current: string[],
      setter: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
      if (current.includes(value)) {
        setter(current.filter((v) => v !== value));
      } else {
        setter([...current, value]);
      }
    };


const validateNoteRealtime = (value: string) => {
  const validation = validateNoteDescription(value);
  if (!validation.valid) {
    setNoteError(validation.message);
    setNoteValid(false);
  } else {
    setNoteError("");
    setNoteValid(true);
  }
};
// Columns visibility
const [visibleColumns, setVisibleColumns] = useState<Record<string, boolean>>({
  index: true,
  notes_decription: true,
  actions: true,
});

const handleColumnToggle = (colKey: string) => {
  setVisibleColumns((prev) => ({
    ...prev,
    [colKey]: !prev[colKey],
  }));
};

// Filter state
const [filterNotes, setFilterNotes] = useState<string[]>([]);
const [filterNoteSearch, setFilterNoteSearch] = useState("");


  useEffect(() => {
    const styleId = "animated-badge-keyframes";
    if (!document.getElementById(styleId)) {
      const styleSheet = document.createElement("style");
      styleSheet.id = styleId;
      styleSheet.innerText = `
        @keyframes shine {
          0% {
            transform: skewX(-20deg) translateX(-150%);
          }
          50% {
             transform: skewX(-20deg) translateX(150%);
          }
          100% {
            transform: skewX(-20deg) translateX(150%);
          }
        }
      `;
      document.head.appendChild(styleSheet);
    }
  }, []);

  useEffect(() => {
    if (userId) fetchNotes();
  }, [userId]);

  const fetchNotes = async () => {
    if (!userId) return;

    setLoading(true);
    try {
      const data: Note[] = await getNotesByUserId(userId);
      setNotes(data);
    } catch (error) {
      console.error("Error fetching notes:", error);
      console.error("Failed to fetch notes. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const processedNotes = notes
  .filter((note) =>
    filterNotes.length > 0 ? filterNotes.includes(note.notes_decription) : true
  )
  .filter((note) =>
    note.notes_decription.toLowerCase().includes(searchTerm.toLowerCase())
  )
  .sort((a, b) => {
    if (sortOption === "ascending")
      return a.notes_decription.localeCompare(b.notes_decription);
    else return b.notes_decription.localeCompare(a.notes_decription);
  });

const uniqueNote = useMemo(
    () =>
      Array.from(
        new Set(notes.map((d) => d.notes_decription?.trim() || ""))
      ).filter((n) => n),
    [notes]
  );

  const resetForm = () => {
    setNoteInput("");
    setEditNoteId(null);
    setNoteError("");
  setNoteValid(false);
  };

  const handleEditClick = (note: Note) => {
    setEditNoteId(note.note_id);
    setNoteInput(note.notes_decription);
    validateNoteRealtime(note.notes_decription);
  };

    const handleSaveNote = async () => {
  // Validate the note input first
  const validation = validateNoteDescription(noteInput);
  if (!validation.valid) {
    toast.error(validation.message);
    return;
  }

  //try {
    setLoading(true);

    if (editNoteId) {
      // === UPDATE NOTE ===
      const updatedNote = await updateNote(editNoteId, noteInput.trim());

      if (!updatedNote) {
        toast.error("Failed to update note. Note not found or server error.");
        return;
      }

      setNotes((prevNotes) =>
        prevNotes.map((n) => (n.note_id === editNoteId ? updatedNote : n))
      );
      // toast.success("Note updated successfully!");
    } else {
      // === CREATE NOTE ===
      const newNote = await createNote(noteInput.trim());

      if (!newNote) {
        toast.error("Failed to create note. Please try again.");
        return;
      }

      setNotes((prevNotes) => [...prevNotes, newNote]);
      // toast.success("Note created successfully!");
    }

    // Success: reset form and close modal
    resetForm();

    // const modalElement = document.getElementById("add_note");
    // if (modalElement) {
    //   // @ts-ignore
    //   const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
    //   modalInstance?.hide();
    // }
  // } catch (error: any) {
  //   console.error("Error saving note:", error);
  //   toast.error(error?.message || "Failed to save note. Please try again.");
  // } finally {
    setLoading(false);
  // }
};

  const handleConfirmDelete = async (id: string | null) => {
    if (!id) return;
    setDeleting(true);
    try {
      setLoading(true);
      await deleteNote(id);
      setNotes((prevNotes) => prevNotes.filter((note) => note.note_id !== id));
      toast.success("Note deleted successfully.");
    } catch (error) {
      console.error("Delete failed:", error);
    } finally {
      setDeleteNoteId(null);
      setLoading(false);
      setDeleting(false);
    }
  };


  const columns: ColumnsType<Note> = [
    {
      title: "No",
      dataIndex: "index",
      width: 80,
      key: "index",
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: "Note",
      dataIndex: "notes_decription",
      key: "notes_decription",
      width: 500,
      render: (text: string) => (
        <div className="note-cell">{highlightMatch(text, searchTerm)}</div>
      ),
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //    width: 150,
    //   key: "type",
    // },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (_: any, record: Note) => (
        <div className="d-flex gap-2">
          <button
            className="btn btn-sm btn-outline-primary"
            data-bs-toggle="modal"
            data-bs-target="#add_note"
            onClick={() => handleEditClick(record)}
          >
            <i className="ti ti-edit" />
          </button>
          <button
            className="btn btn-sm btn-outline-danger"
            data-bs-toggle="modal"
            data-bs-target="#delete_note"
            onClick={() => setDeleteNoteId(record.note_id)}
          >
            <i className="ti ti-trash" />
          </button>
        </div>
      ),
    }

  ];

  const columnMap = useMemo(() => {
  const map: Record<string, ColumnsType<Note>[number]> = {};
  columns.forEach((col) => {
    if (col.key) map[col.key.toString()] = col;
  });
  return map;
}, [columns]);


  return (
    <>
      <PageLoadProgressBar />
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="page-header mb-0">
                <div className="row align-items-center">
                  <div className="col-sm-8">
                    <h4 className="page-title"><i className="bi bi-journal-bookmark text-primary me-2" />Notes</h4>
                  </div>
                </div>
              </div>
               {/* Breadcrumb */}
              <nav aria-label="breadcrumb" className="page-header-breadcrumb mb-3">
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link 
                      to={userRole === "admin" ? route.dealsDashboard : route.leadsDashboard}
                      style={{ 
                        color: "#9595b5", 
                        textDecoration: "none",
                        transition: "color 0.2s ease"
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.color = "#E41F07"}
                      onMouseLeave={(e) => e.currentTarget.style.color = "#9595b5"}
                    >
                      Dashboard
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Notes
                  </li>
                </ol>
              </nav>
              {/* /Breadcrumb */}

              <div className="card">
                <div className="card-header">
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                      <div className="icon-form mb-3 mb-sm-0 ms-3">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search Note"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        {searchTerm && (
                          <button
                            type="button"
                            className="btn-close position-absolute end-0 top-50 translate-middle-y me-3"
                            style={{ zIndex: 10, fontSize: "12px" }}
                            onClick={() => setSearchTerm("")}
                            aria-label="Clear search"
                          />
                        )}
                      </div>
                    </div>
                    <div className="col text-sm-end">
                      <button
                        className="btn btn-primary me-3"
                        data-bs-toggle="modal"
                        data-bs-target="#add_note"
                        onClick={resetForm}
                        style={{
                          position: "relative",
                          overflow: "hidden",
                        }}
                      >
                        <i className="ti ti-square-rounded-plus me-2" style={{ position: "relative", zIndex: 2 }} />
                        <span style={{ position: "relative", zIndex: 2 }}>Add Note</span>
                        <span
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%)",
                            transform: "skewX(-20deg) translateX(-150%)",
                            animation: "shine 3s infinite",
                          }}
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap row-gap-2">
                  <div className="d-flex align-items-center flex-wrap row-gap-2">
                    <div className="dropdown me-2">
      <Link to="#" className="dropdown-toggle dropdown-active-toggle common-sort-dropdown-toggle" data-bs-toggle="dropdown">
        <i className="ti ti-sort-ascending-2" /> Sort
      </Link>
      <div className="dropdown-menu dropdown-menu-start">
        <ul className="list-unstyled mb-0">
          {["ascending", "descending"].map((val) => {
            const label = val === "ascending" ? "Ascending" : "Descending";
            const isActive = sortOption === val;
            return (
              <li key={val}>
                <Link
                  to="#"
                  className={`dropdown-item d-flex justify-content-between align-items-center ${
                    isActive ? "fw-bold text-primary" : ""
                  }`}
                  onClick={() =>
                    setSortOption(val as "ascending" | "descending")
                  }
                >
                  <span>
                    <i className="ti ti-circle-chevron-right me-1" /> {label}
                  </span>
                  {isActive && <i className="ti ti-check" />}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  </div>

  
  <div className="d-flex align-items-center flex-wrap row-gap-2">
  {/* ==== Manage Columns Dropdown ==== */}
  <div className="dropdown me-2 ms-2">
                        <Link
                          to="#"
                          className="btn bg-soft-purple text-purple"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-columns-3 me-2" />
                          Manage Columns
                        </Link>
                        <div
                          className="dropdown-menu dropdown-menu-end dropdown-md p-3"
                          style={{ minWidth: "250px" }}
                        >
                          <h4 className="mb-2 fw-semibold">Manage Columns</h4>
                          <p className="mb-3">
                            Drag and drop columns to reorder and toggle
                            visibility.
                          </p>
                          <div className="border-top pt-3">
                            <ColumnManagement
                              columnKeys={columnKeys}
                              visibleColumns={visibleColumns}
                              onColumnOrderChange={(newOrder) => setColumnKeys(newOrder)}
                              onColumnToggle={handleColumnToggle}
                              fixedKeys={["actions"]} // Keeping Action fixed at the end or wherever it is
                            />
                          </div>
                        </div>
                      </div>

  {/* ==== Filter Dropdown ==== */}
  <div className="form-sorts dropdown">
                          <Link
                            to="#"
                            className="dropdown-toggle dropdown-active-toggle common-filter-btn d-flex align-items-center gap-2 fw-medium"
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                          >
  
  
                          <i className="ti ti-filter-share" /> Filter
                          {(filterNotes.length > 0 
                            )}
                        </Link>
  
                        <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                          <div className="filter-set-view">
                            <div className="filter-set-head">
                              <h4>
                                <i className="ti ti-filter-share" /> Filter
                              </h4>
                            </div>
  
                            <div className="accordion" id="accordionExample">
                              {/* 🔹 Lead Source Name Filter */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "Note"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("Note")
                                    }
                                  >
                                    Note
                                  </Link>
                                  {filterNotes.length > 0 && (
                                    <span className="badge filter-btn-badge bg-primary rounded-pill small">
                                      {filterNotes.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "Note" && (
                                  <div className="filter-set-contents accordion-collapse collapse show">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Lead Source"
                                          value={filterNoteSearch}
                                          onChange={(e) =>
                                            setFilterNoteSearch(e.target.value)
                                          }
                                        />
                                      </div>
  
                                      <ul className="list-unstyled mb-0">
                                        {uniqueNote
                                          .filter((n) =>
                                            n
                                              .toLowerCase()
                                              .includes(
                                                filterNoteSearch.toLowerCase()
                                              )
                                          )
                                          .map((name) => (
                                            <li key={name}>
                                              <div className="filter-checks">
                                                <label className="checkboxs">
                                                  <input
                                                    type="checkbox"
                                                    checked={filterNotes.includes(
                                                      name
                                                    )}
                                                    onChange={() =>
                                                      handleFilterChange(
                                                        name,
                                                        filterNotes,
                                                        setFilterNotes
                                                      )
                                                    }
                                                  />
                                                  <span className="checkmarks" />{" "}
                                                  {name}
                                                </label>
                                              </div>
                                            </li>
                                          ))}
  
                                        {uniqueNote.filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(
                                              filterNoteSearch.toLowerCase()
                                            )
                                        ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                      </ul>
                                    </div>
                                  </div>
                                )}
                              </div>
                            
                            </div>
  
                            {/* Reset / Apply Buttons */}
                            <div className="filter-reset-btns mt-3">
                              <div className="row">
                                <div className="col-6">
                                  <Link
                                    to="#"
                                    className="btn btn-light w-100"
                                    onClick={() => {
                                      setFilterNotes([]);
                                      setFilterNoteSearch("");
                                      setOpenAccordion(null);
                                    }}
                                  >
                                    Reset
                                  </Link>
                                </div>
                                <div className="col-6">
                                  <Link
                                    to="#"
                                    className="btn btn-primary w-100"
                                    data-bs-dismiss="dropdown"
                                  >
                                    Apply
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
</div>

</div>{(filterNotes.length > 0 ||
                  
                  searchTerm.length > 0 || // ✅ ADD
                  selectedRows.length > 0 ||
                  sortOption !== "ascending") && ( // ✅ ADD
                    <div className="active-filters d-flex flex-wrap gap-2 mb-4 align-items-center-3">
                      {/* Search */}
                      {searchTerm.length > 0 && (
                        <div className="alert alert-primary py-2 mb-0">
                          <strong>Search:</strong> {searchTerm}
                          <i
                            className="ti ti-x ms-2 cursor-pointer"
                            onClick={() => setSearchTerm("")}
                          />
                        </div>
                      )}

                      {/* Sort */}
                      {sortOption !== "ascending" && (
                        <div className="alert alert-secondary py-2 mb-0">
                          <strong>Sort:</strong>{" "}
                          {sortOption
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase())}
                          <i
                            className="ti ti-x ms-2 cursor-pointer"
                            onClick={() => setSortOption("ascending")}
                          />
                        </div>
                      )}

                      {filterNotes.length > 0 && (
                        <div className="alert alert-primary py-2 mb-0">
                          <strong>Note:</strong> {filterNotes.join(", ")}
                          <i
                            className="ti ti-x ms-2 cursor-pointer"
                            onClick={() => setFilterNotes([])}
                          />
                        </div>
                      )}
                      
                    </div>
                  )}

  <div className="table-responsive custom-table">
    {loading ? (
      <div className="text-center my-4">Loading...</div>
    ) : error ? (
      <div className="text-center text-danger my-4">{error}</div>
    ) : (
      <Table
  columns={columnKeys
  .filter((key) => visibleColumns[key])
  .map((key) => columnMap[key])
  .filter(Boolean)}

  dataSource={processedNotes.map((n, i) => ({ ...n, index: i + 1 }))}
  rowKey="note_id"
  className="custom-table"
  emptyText="No Notes found"
  emptyIcon="ti ti-notebook-off"
  enableRowSelection={false}
  loading={loading}
  draggable={true}              // ✅ row drag
  enableColumnDrag={true}
  recordLabel="Notes"
  pagination={{
    current: currentPage,
    pageSize: pageSize,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50", "75", "100"],
    onChange: (page: number, size: number) => {
      setCurrentPage(page);
      setPageSize(size);
    },
  }}
  rowSelection={{
                            type: "checkbox",
                            selectedRowKeys: selectedRows,
                            onChange: (selectedRowKeys: React.Key[]) => {
                              setSelectedRows(selectedRowKeys as string[]);
                            },
                          }}
  onRowOrderChange={handleRowOrderChange}
  onColumnOrderChange={(newCols: any[]) => {
                          // Get the new order of non-sticky columns from the dragged columns
                          const newOrderedKeys = newCols
                            .filter((c) => !c.fixed) // Only non-sticky columns
                            .map((c) => c.key || c.dataIndex)
                            .filter(
                              (key) =>
                                key !== undefined && key !== null && key !== ""
                            ); // Remove invalid keys

                          // Preserve columns that are not in newCols (hidden columns) by merging with existing columnKeys
                          const existingKeys = columnKeys;
                          const allNonStickyKeys = defaultColumnOrder; // All possible non-sticky column keys

                          // Create a new array that:
                          // 1. Uses the new order for visible columns
                          // 2. Preserves the order of hidden columns that aren't in newCols
                          const preservedKeys = existingKeys.filter(
                            (key) => !newOrderedKeys.includes(key)
                          );
                          const finalKeys = [
                            ...newOrderedKeys,
                            ...preservedKeys,
                          ];

                          // Ensure all default columns are included (in case some are missing)
                          const missingKeys = allNonStickyKeys.filter(
                            (key) => !finalKeys.includes(key)
                          );
                          const completeKeys = [...finalKeys, ...missingKeys];

                          setColumnKeys(completeKeys);
                          // Don't auto-save, let user decide on navigation/refresh
                        }}
  scroll={{ x: "max-content" }}
  components={{
    
  }}
/>
    )}
  </div>
</div>

              </div>

              {/* /Card */}
            </div>
          </div>
        </div>

        {/* Add/Edit Modal */}
        <div
          className="modal fade effect-modal-show"
          id="add_note"
          tabIndex={-1}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-primary fw-bold d-flex align-items-center">
  {editNoteId ? (
    <>
      <i className="ti ti-edit me-2 fs-20" />
      Edit Note
    </>
  ) : (
    <>
      <i className="ti ti-square-rounded-plus-filled me-2 fs-20" />
      Add Note
    </>
  )}
</h5>

                <button
                  className="btn-close custom-btn-close border p-1 me-0 text-dark"
                  data-bs-dismiss="modal"
                  onClick={resetForm}
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className={`col-form-label fw-semibold ${noteError ? "pro-shake text-danger" : "text-dark"
                      }`}>
                      Note <span className="text-danger">*</span>
                    </label>
                    <textarea
  className={`form-control ${noteError ? 'is-invalid' : noteValid ? 'is-valid' : ''}`}
  rows={4}
  placeholder="Write your note here..."
  value={noteInput}
  onChange={(e) => {
    const newValue = e.target.value;
    setNoteInput(newValue);
    validateNoteRealtime(newValue);
  }}
></textarea>
{noteError ? (
  <div className="invalid-feedback d-block">
    {noteError}
  </div>
) : noteValid ? (
  <div className="valid-feedback d-block">
    Looks good!
  </div>
) : null}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                    onClick={resetForm}
                  >
                    Cancel
                  </button>
                  <button
  type="button"
  className="btn btn-primary"
  data-bs-dismiss="modal"
  disabled={loading || !noteValid || !noteInput.trim()}
  onClick={handleSaveNote}
>
  {loading ? "Saving..." : "Save Note"}
</button>
                </div>
              </form>
            </div>
          </div>
        </div>
<ModalDeleteEffect />
        {/* Delete Modal */}
        <div
          className="modal fade effect-modal-show"
          id="delete_note"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="deleteNoteLabel"
          aria-hidden="true"
        >
        <div className="modal-dialog modal-dialog-centered ">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title text-danger fw-bold"
                id="deleteNoteLabel"
              >
                <i className="ti ti-alert-triangle me-2" />
                Confirm Deletion
              </h5>
              <button
                type="button"
                className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body text-center ">
              <div className="avatar avatar-xl bg-danger-light rounded-circle mb-4 mx-auto effect-avatar-pulse">
                <i className="ti ti-trash fs-40 text-danger" />
              </div>
              <h4 className="fw-bold text-dark mb-3">
                Delete This Notes?
              </h4>
              <p className="text-muted fs-15 mb-4 px-4">
                This action <strong>cannot be undone</strong>. The Notes
                will be
                <strong> permanently removed</strong>.
              </p>
              
              <div className="d-flex gap-3 justify-content-center mt-4">
                <button
                  type="button"
                  className="btn btn-light px-5 py-2 fw-medium"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger px-5 py-2 fw-medium"
                  data-bs-dismiss="modal"
                  onClick={() => handleConfirmDelete(deleteNoteId)}
                  disabled={deleting}
                >
                  {deleting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                      Deleting...
                    </>
                  ) : (
                    <>
                      <i className="ti ti-trash me-2" />
                      Yes, Delete It
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <SaveModal />
      <ScrollToTop />
    </>
  );
};

export default Notes;
